import { useMemo } from 'react';

import { type AssistanceServiceInputParam } from '@atlassian/conversation-assistant-service/services/assistance-service/main';

import { useGlobalConfig } from '../global-config';

export const useAssistanceServiceParams = ({
	touchpointSource,
}: Pick<
	AssistanceServiceInputParam['assistanceServiceParams'],
	'touchpointSource'
>): AssistanceServiceInputParam['assistanceServiceParams'] => {
	const { productHeader, siteId, experienceId, assistanceServiceConfig } = useGlobalConfig();

	return useMemo(
		() => ({
			product: productHeader,
			experienceId,
			touchpointSource,
			siteId,
			headers: assistanceServiceConfig?.headers,
			channelId: assistanceServiceConfig?.channelId,
		}),
		[
			productHeader,
			experienceId,
			touchpointSource,
			siteId,
			assistanceServiceConfig?.headers,
			assistanceServiceConfig?.channelId,
		],
	);
};
